import React from 'react'

import { useAuthDataContext } from '../../_providers/Auth'
import { trans } from '../../_providers/Translation'

const RADIUS = 70
const CIRCUMFERENCE = 2 * Math.PI * RADIUS

/**
 * Прозорец с обратно броене преди автоматичния изход при неактивност.
 * Затваря се само чрез един от двата бутона - ако потребителят не избере,
 * брояча стига до 0 и излиза автоматично.
 */
function SessionExpiring() {

    const auth = useAuthDataContext()

    if (!auth.inactivityWarning) {
        return null
    }

    const total = Math.round(auth.inactivityWarningBefore / 1000)
    const secondsLeft = Math.min(auth.inactivitySecondsLeft, total)

    const minutes = Math.floor(secondsLeft / 60)
    const seconds = secondsLeft % 60

    const progress = total > 0 ? secondsLeft / total : 0

    return (
        <div className="overlay visible session-expiring">
            <div className="box show">

                <h3>
                    {trans('headings.sessionExpiring')}
                </h3>

                <p>
                    {trans('subheadings.sessionExpiring')}
                </p>

                <div className="countdown">
                    <svg viewBox="0 0 160 160">
                        <circle
                            className="track"
                            cx="80"
                            cy="80"
                            r={RADIUS}
                        />
                        <circle
                            className="progress"
                            cx="80"
                            cy="80"
                            r={RADIUS}
                            strokeDasharray={CIRCUMFERENCE}
                            strokeDashoffset={CIRCUMFERENCE * (1 - progress)}
                        />
                    </svg>

                    <span className="time">
                        {minutes}:{String(seconds).padStart(2, '0')}
                    </span>
                </div>

                <div className="buttons">
                    <button
                        className="button-primary"
                        onClick={auth.keepSessionAlive}
                    >
                        {trans('buttons.keepMeLoggedIn')}
                    </button>

                    <button
                        className="button-secondary"
                        onClick={auth.logoutNow}
                    >
                        {trans('buttons.logMeOut')}
                    </button>
                </div>

            </div>
        </div>
    )
}

export default SessionExpiring
